module.exports = __webpack_public_path__ + "img/circle3yellow.a3dea766.png";